import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const MOBILE_FACTOR = 0.7;
const DESKTOP_FACTOR = 1.0;


function initParallaxItems(selector, speeds) {
    const items = Array.from(document.querySelectorAll(selector));
    if (!items.length) return;

    const onScroll = () => {
        const scrollY = window.scrollY;
        const factor = window.innerWidth < 768 ? MOBILE_FACTOR : DESKTOP_FACTOR;
        items.forEach((item, i) => {
            const speed = speeds[i % speeds.length];
            item.style.transform = `translateY(${scrollY * speed * factor}px)`;
        });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
}

export function initFlyingIconsParallax() {
    if (prefersReducedMotion) return;

    initParallaxItems(
        '.heroFlyingIcons__grid .heroFlyingIconsItem',
        [0.18, 0.28, 0.12, 0.32, 0.22, 0.15, 0.26, 0.20, 0.30, 0.10, 0.24]
    );

    const flyingImagesContainer = document.querySelector('.heroFlyingImages');
    if (!flyingImagesContainer) return;

    const flyingImages = Array.from(flyingImagesContainer.querySelectorAll('.heroFlyingImagesItem'));
    if (!flyingImages.length) return;

    flyingImages.forEach((item) => {
        gsap.fromTo(item,
            { opacity: 0, y: 240 },
            {
                opacity: 1,
                y: 0,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: item,
                    start: 'top 95%',
                    end: 'top 50%',
                    scrub: 1.5,
                },
            }
        );
    });
}

export function initHeroAboutUsParallax() {
    if (prefersReducedMotion) return;

    const items = document.querySelectorAll('.heroAboutUs__images .heroAboutUs__media');
    if (!items.length) return;

    const container = document.querySelector('.heroAboutUs__images');
    if (!container) return;

    items.forEach((item) => {
        gsap.fromTo(item,
            { opacity: 0, y: 240 },
            {
                opacity: 1,
                y: 0,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: item,
                    start: 'top 95%',
                    end: 'top 50%',
                    scrub: 1.5,
                },
            }
        );
    });
}

function animateCounter(el) {
    const raw = el.textContent.trim();
    const match = raw.match(/^(\d+)(.*)/);
    if (!match) return;

    const targetNum = parseInt(match[1], 10);
    const suffix = match[2] || '';
    const padLength = match[1].length;
    const duration = 1000;
    const startTime = performance.now();

    function update(now) {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(2, -10 * progress);
        const current = Math.round(eased * targetNum);
        el.textContent = String(current).padStart(padLength, '0') + suffix;
        if (progress < 1) {
            requestAnimationFrame(update);
        } else {
            el.textContent = raw;
        }
    }

    requestAnimationFrame(update);
}

export function initHeroAboutUsAnimations() {
    const sections = document.querySelectorAll('.heroAboutUs__section');
    if (!sections.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            if (!prefersReducedMotion) {
                const counter = entry.target.querySelector('.heroAboutUs__sectionCounter');
                if (counter) {
                    setTimeout(() => animateCounter(counter), 350);
                }
            }
            observer.unobserve(entry.target);
        });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });

    sections.forEach(section => observer.observe(section));
}